/**
 * ResponsiveTable — renders antd <Table> on desktop, <MobileCardList> on mobile.
 *
 * Drop-in replacement for antd <Table>.  Reads isPC from Redux internally.
 * Only the import line needs to change:
 *
 *   // before
 *   import { Table } from "antd";
 *   // after
 *   import ResponsiveTable from "@components/ResponsiveTable";
 *
 * JSX stays the same: <ResponsiveTable columns={...} dataSource={...} />
 */
import React from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import MobileCardList from "../MobileCardList";

const ResponsiveTable = (props) => {
  const isPC = useSelector((s) => s.App?.isPC ?? true);
  const {
    // Mobile-only extras
    showToolbar,
    onRefresh,
    // Rest are antd Table props
    ...rest
  } = props;

  if (isPC) {
    return <Table {...rest} />;
  }

  // Mobile: card list
  const {
    columns, dataSource, loading, rowKey, rowSelection,
    pagination, onChange, expandable, onRow,
    title, footer, className, style, size, locale,
    mobileTitleOnClick,
    mobileRowActions,
    hideMobileColumnActions,
    hideMobileTableExpand,
    mobileCardHeaderRender,
    mobileExpandedExcludeKeys,
    mobileExpandedIncludeKeys,
  } = rest;

  return (
    <MobileCardList
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      rowKey={rowKey || "id"}
      rowSelection={rowSelection}
      pagination={pagination}
      onChange={onChange}
      expandable={expandable}
      onRow={onRow}
      title={title}
      footer={footer}
      className={className}
      style={style}
      size={size}
      locale={locale}
      mobileRowActions={mobileRowActions}
      hideMobileColumnActions={hideMobileColumnActions}
      hideMobileTableExpand={hideMobileTableExpand}
      mobileCardHeaderRender={mobileCardHeaderRender}
      mobileTitleOnClick={mobileTitleOnClick}
      mobileExpandedExcludeKeys={mobileExpandedExcludeKeys}
      mobileExpandedIncludeKeys={mobileExpandedIncludeKeys}
      showToolbar={showToolbar !== undefined ? showToolbar : true}
      onRefresh={onRefresh}
    />
  );
};

export default ResponsiveTable;
